export default "assets/images/leaf-11ee247d.svg";